<template>
  <span class="GamWalkPrompt">
    {{ localize('walk.prompt.walk') }}
    <span v-for="i in DOT_COUNT" :key="i" class="walk-dot" :style="{ '--dot-index': i - 1 }">·</span>
  </span>
</template>

<script lang="ts" setup>
import { localize } from '@/core/gambits';

const DOT_COUNT = 6;
</script>

<style lang="scss" scoped>
.GamWalkPrompt {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #ffffff;
  white-space: nowrap;
}

.walk-dot {
  animation: walk-prompt-blink 1.8s infinite;
  animation-delay: calc(var(--dot-index) * 0.15s);
}

@keyframes walk-prompt-blink {
  0%,
  55%,
  100% {
    opacity: 0.3;
  }

  25% {
    opacity: 1;
  }
}
</style>
